import { useState } from 'react';
import { useEditor } from '@smartfire/glue-ui/block';
import { Button } from 'src/components/Button';
import { basicPhoneFormatter } from 'src/utils/misc/functions';
import { PopUp } from '../../../../components/PopUp';
import { RenderLegacyForm } from '@smartfire/glue-ui/components';
import { ReactComponent as RightArrow } from '../../../../assets/icons/arrow_right.svg';
import Store from 'src/api/public/Store';

// icons
import { ReactComponent as PhoneIcon } from 'src/assets/icons/phone.svg';
import { ReactComponent as StreetMapIcon } from 'src/assets/icons/streetmap.svg';
import { ReactComponent as MailIcon } from 'src/assets/icons/mail.svg';

import style from './style.module.scss';
import clsx from 'clsx';
import { useFormsConfig } from 'src/hooks/useFormsConfig';
import { urlConfig } from '../../../../config/urlConfig';
import { useAmplitudeWebsite } from '../../../../hooks/useAmplitudeWebsite';

interface TileProps extends React.HTMLAttributes<HTMLDivElement> {
    store: Store;
    isMain?: boolean;
    embedLayout?: true;
}

export const Tile: React.FC<TileProps> = ({ store, isMain, embedLayout, ...props }) => {
    const [formOpen, setFormOpen] = useState(false);
    const { isEditing } = useEditor();
    const config = useFormsConfig();
    const { isEasyVO } = useAmplitudeWebsite();

    return (
        <div {...props} className={clsx(style.tile, isMain && style.main, props.className)}>
            <div className={style.content}>
                <div className={style.col}>
                    <h2 className={style.colheader}>{store.name}</h2>
                    <span className={style.address}>{store.address}</span>
                    <span className={style.address}>{store.zipcode + ' ' + store.city}</span>
                </div>
                <div className={style.col}>
                    <span className={style.colheader}>Horaires d’ouverture</span>
                    <span className={style.horaires} dangerouslySetInnerHTML={{ __html: store.openingHours }} />
                </div>
                <div className={style.contactCol}>
                    {store.phoneNumber && (
                        <a
                            target="_blank"
                            rel="noopener noreferrer"
                            href={!isEditing ? 'tel:' + store.phoneNumber : '#top'}
                        >
                            <h3>
                                <PhoneIcon className={style.icon} />
                                {basicPhoneFormatter(store.phoneNumber)}
                            </h3>
                        </a>
                    )}
                    <div className={style.contact} onClick={() => setFormOpen(true)}>
                        <h3>
                            <MailIcon className={style.icon} />
                            Contactez-nous
                        </h3>
                    </div>
                    <a
                        target="_blank"
                        rel="noopener noreferrer"
                        href={
                            !isEditing
                                ? 'https://www.google.com/maps/place/' + store.latitude + ',' + store.longitude
                                : '#top'
                        }
                    >
                        <StreetMapIcon className={style.icon} />
                        <span>Plan d'accès</span>
                    </a>
                </div>
                {isEasyVO && (
                    <Button href={urlConfig.car.search.computedUrl({ store: [store.id] })} className={style.button}>
                        <span className={style.buttonText}>Voir les voitures</span>{' '}
                        <RightArrow className={style.icon} />
                    </Button>
                )}
            </div>
            <PopUp isVisible={formOpen} onClose={() => setFormOpen(false)}>
                <RenderLegacyForm slug={config?.forms?.pointDeVente}>
                    <input type="hidden" name="store" value={store.id} />
                </RenderLegacyForm>
            </PopUp>
        </div>
    );
};
